module.exports = __webpack_public_path__ + "static/iphoneduo-97d12fbf2f73f4bf8cd0f5c8f54ad373.png";